export class PagedApiResponse<T> {
    rows: Array<T>;
    body: Array<T>;
    count: number;
}
